/**
 * Retrieves Configuration from window (PUBLIC_CONSTS)
 * @returns {Object} configuration file for optimizely
 */
const parseConfig = () => {
  const { PUBLIC_CONSTS } = window;
  const result = {};
  if (!PUBLIC_CONSTS) {
    return result;
  }

  ['OPTIMIZELY_SDK_KEY', 'CURRENT_USER_EXTERNAL_ID'].forEach((key) => {
    const hasKey = PUBLIC_CONSTS.hasOwnProperty(key);
    if (!hasKey) {
      return;
    }

    result[key] = PUBLIC_CONSTS[key];
  });

  return result;
};

export default parseConfig();
